// extracted by mini-css-extract-plugin
module.exports = {"link":"_2e0PN5","name":"_3s7xmp"};